import React, { useEffect } from 'react'
import * as device from 'react-device-detect';
import { Window } from "../../model/CustomModel";
declare var window: Window;


const HoEnd = (props:any) => {
    const isResult = props.location.state === undefined ? false : props.location.state.result;
    console.log(isResult);
    const isAndroid = device.isAndroid;
    const isiOS = device.isIOS || device.isIOS13 || device.isIPhone13 || device.isIPad13;

    const resultHandler = () => {
         if (isAndroid) {
             console.log("android");
             window.Android.setSurveyResult(true);
         } else if (isiOS) {
             console.log("ios");
             window.webkit.messageHandlers.setSurveyResult.postMessage(true);
         } else {
             console.log("etc");
             alert("등록되지않은 기기입니다. \n고객센터에 문의 바랍니다.")
             console.log('can not device type');
         }
    }

    useEffect(() => {
        if(isResult){
            resultHandler();
        }
    }, []);
    return (
        <div className={"survey_ho"}>
            <div className={"container survey_container"}>
                <section>
                    <div>
                        <img src="/img/survey/visual_banner.jpg" className="rounded img-fluid" alt=""/>
                    </div>
                </section>

                <section>
                    <h4>참여에 감사드립니다.</h4>
                    <p>안내사항</p>
                    <div className="mb-3 row">
                        <div className="info">
                            <ul>
                                <li>경품 지급은 개인정보 수집, 이용 및 제공에 동의한 고객을 대상으로 합니다.</li>
                                <li>완주 경품은 익월 초 일괄 발송될 예정이며, 발송 일정은 당사 사정으로 변경될 수 있습니다. (ex. 6월에 투어 완주 시, 7월 초에 배송)</li>
                                <li>완주 경품, SNS 이벤트 경품, 자원 봉사 시간 발급은 모두 참여 가능하며, 참여 횟수는 1회로 제한됩니다.</li>
                                <li>SNS 이벤트는 호국 보훈 스탬프 투어가 끝나고, 9월 내에 게시글이 우수한 30명을 선발하여 경품을 발송합니다.</li>
                                <li>완주 경품은 변경될 수 있으며, 재고 소진 시 완주증만 발부됩니다.</li>
                                <li>설문에 작성된 고객 정보로 경품을 발송해 드리며, 정보 미 등록 및 오류로 인해 미 배송될 경우 재발송이 불가합니다.</li>
                            </ul>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default HoEnd;
